// extracted by mini-css-extract-plugin
export default {"tableContainer":"Notifications_tableContainer__HU4v8","table":"Notifications_table__k7VD9","noWorkersText":"Notifications_noWorkersText__bTkHJ","form":"Notifications_form__URVZ+"};